var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7C63A4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8538 16.354L17.3538 20.854C17.2599 20.9478 17.1327 21.0006 17 21.0006C16.8673 21.0006 16.7401 20.9478 16.6462 20.854C16.5524 20.7602 16.4997 20.633 16.4997 20.5003C16.4997 20.3676 16.5524 20.2403 16.6462 20.1465L20.2931 16.5003H10.5C10.3674 16.5003 10.2402 16.4476 10.1464 16.3538C10.0527 16.2601 10 16.1329 10 16.0003C10 15.8677 10.0527 15.7405 10.1464 15.6467C10.2402 15.553 10.3674 15.5003 10.5 15.5003H20.2931L16.6462 11.854C16.5524 11.7602 16.4997 11.633 16.4997 11.5003C16.4997 11.3676 16.5524 11.2403 16.6462 11.1465C16.7401 11.0527 16.8673 11 17 11C17.1327 11 17.2599 11.0527 17.3538 11.1465L21.8538 15.6465C21.9002 15.693 21.9371 15.7481 21.9623 15.8088C21.9874 15.8695 22.0004 15.9346 22.0004 16.0003C22.0004 16.066 21.9874 16.131 21.9623 16.1917C21.9371 16.2524 21.9002 16.3076 21.8538 16.354Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.b41aa51a650fec8f1469d7a7517c0949.svg";
export { ForwardRef as ReactComponent };